/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { replacePXinStringWithEM, pxToEm, disable, mediaQuery } from '@insticator/insticator-ui'; // iui-utils
import { url } from 'utils/urls';


/* ++++++++++ --------------- EXPORT : REQUEST RATING WIDGET : STYLES --------------- ++++++++++ */
export default theme => ({
    requestratingwidget: {
        backgroundImage: `url(${url.image}/illustration-bubble-background.svg)`,
        background: 'right top',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'auto 100%',
        padding: `${pxToEm(70)} 5% 6.25em`,
        marginBottom: pxToEm(50),
    
        // flex to align copy and graphic
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',


        // copy
        '& .requeststatus':{
            maxWidth: pxToEm(450),
            margin: replacePXinStringWithEM('85px 104px 85px 0'),

            // animation
            opacity: '0',
            animationName: 'fadeInLeft',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            animationDelay: '.1s',
        },
        // graphic
        '& .graphic': {
            flex: '1',
            maxWidth: pxToEm(675),
            minWidth: pxToEm(300),
            '& img': {
                width: '100%',
                height: 'auto'
            },

            // animation
            opacity: '0',
            animationName: 'fadeInRight',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            animationDelay: '.1s',
        },
        '&.disabled-true': {
            extend: disable
        }
    },
    [mediaQuery.thinnest]:{
        requestratingwidget: {
            display: 'block',
            '& .requeststatus': {
                marginRight: 0,
                marginTop: '16px',
                '& .button': {
                    '& span': {
                        whiteSpace: 'pre-wrap',
                    }
                }
            }
        }
    }
});